export const buildRelativePermissionsLink = (firmUuid: string): string =>
  `${firmUuid}/edit-firm`;

export const buildRelativeRemoveFirmLink = (firmUuid: string): string =>
  `${firmUuid}/remove-firm`;

export const buildRelativeRemovePendingFirmLink = (firmUuid: string): string =>
  `${firmUuid}/remove-pending-firm`;
